import { render, staticRenderFns } from "./_ProxyStoreEditSendInfo.vue?vue&type=template&id=784b75c6&"
import script from "./_ProxyStoreEditSendInfo.vue?vue&type=script&lang=js&"
export * from "./_ProxyStoreEditSendInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports